
const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
  { value: "DC", label: "District of Columbia" },
];

export const formSchemas = {

  "COD Credit Application": [
    {
      title: "Personal Info",   // — Personal Info (same as COD Credit) —
      fields: [
        { name: "legalFirstName", label: "Legal First Name", type: "text", required: true },
        { name: "lastName", label: "Last Name", type: "text", required: true },
        { name: "ssn", label: "SSN", type: "number", required: true },
        { name: "mainPhonePersonal", label: "Main Phone", type: "phone", required: true },
        { name: "emailPersonal", label: "Email", type: "text", required: true },
      ]
    },
    // — Address Information —
    {
      title: "Address Information",
      shipping: false,
      fields: [
        { name: "billingAddress", label: "Billing Address", type: "text", required: true },
        { name: "billingAddress2", label: "Billing Address 2", type: "text", required: false },        
        { name: "billingCity", label: "City", type: "text", required: true },
        { name: "billingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "billingZip", label: "Zip Code", type: "text", required: true },
        { name: "billingContact", label: "Billing Contact", type: "text", required: true },
        { name: "billingPhone", label: "Billing Phone", type: "phone", required: true },
        { name: "billingExt", label: "Extension", type: "phone", required: false },
        { name: "billingEmail", label: "Billing Email", type: "text", required: true },
      ]
    },
    // — Shipping (required; can copy from billing) —
    {
      title: "Shipping Information",
      sectionInfo: "Required. Check \"Same as Billing Address\" to copy your billing details.",
      fields: [
        { name: "shippingAddress", label: "Shipping Address", type: "text", required: true },
        { name: "shippingAddress2", label: "Shipping Address 2", type: "text", required: false },
        { name: "shippingCity", label: "City", type: "text", required: true },
        { name: "shippingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "shippingZip", label: "Zip Code", type: "text", required: true },
        { name: "shippingContact", label: "Shipping Contact", type: "text", required: true },
        { name: "shippingPhone", label: "Shipping Phone", type: "phone", required: true },
        { name: "shippingExt", label: "Extension", type: "phone", required: false },
        { name: "shippingEmail", label: "Shipping Email", type: "text", required: true },
      ]
    }
  ],

  "New Account Application - Personal": [
    {
      title: "Personal Info",
      fields: [
        { name: "legalFirstName", label: "Legal First Name", type: "text", required: true },
        { name: "lastName", label: "Last Name", type: "text", required: true },
        { name: "ssn", label: "SSN", type: "number", required: true },
        { name: "mainPhonePersonal", label: "Main Phone", type: "phone", required: true },
        { name: "emailPersonal", label: "Email", type: "text", required: true },
      ]
    },
    // — Address Information —
    {
      title: "Address Information",
      shipping: false,
      fields: [
        { name: "billingAddress", label: "Billing Address", type: "text", required: true },
        { name: "billingAddress2", label: "Billing Address 2", type: "text", required: false },        
        { name: "billingCity", label: "City", type: "text", required: true },
        { name: "billingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "billingZip", label: "Zip Code", type: "text", required: true },
        { name: "billingContact", label: "Billing Contact", type: "text", required: true },
        { name: "billingPhone", label: "Billing Phone", type: "phone", required: true },
        { name: "billingExt", label: "Extension", type: "phone", required: false },
        { name: "billingEmail", label: "Billing Email", type: "text", required: true },
      ]
    },
    // — Shipping (required; can copy from billing) —
    {
      title: "Shipping Information",
      sectionInfo: "Required. Check \"Same as Billing Address\" to copy your billing details.",
      fields: [
        { name: "shippingAddress", label: "Shipping Address", type: "text", required: true },
        { name: "shippingAddress2", label: "Shipping Address 2", type: "text", required: false },
        { name: "shippingCity", label: "City", type: "text", required: true },
        { name: "shippingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "shippingZip", label: "Zip Code", type: "text", required: true },
        { name: "shippingContact", label: "Shipping Contact", type: "text", required: true },
        { name: "shippingPhone", label: "Shipping Phone", type: "phone", required: true },
        { name: "shippingExt", label: "Extension", type: "phone", required: false },
        { name: "shippingEmail", label: "Shipping Email", type: "text", required: true },
      ]
    },

    // — Signature block —
    {
      title: "TERMS: Net 30 Days from the Invoice Date",
      sectionInfo: "Payment is due within 30 days unless otherwise agreed in writing. Past-due accounts may incur finance charges. Sidney Lee Welding Supply, Inc. reserves the right to suspend credit or place accounts on C.O.D. at any time based on payment history. Cylinders remain the property of Sidney Lee Welding supply, Inc. Rental charges apply unless specified otherwise. We reserve the right to reclaim rented cylinders if invoices remain unpaid or the lease is terminated. Full Terms of Service available at sidneylee.com.\n\nI certify that the information provided in this application is correct and that I am authorized to request credit on behalf of the applicant. \n\nI authorize Sidney Lee Welding Supply, Inc. to verify credit references and use other sources as needed. I agree to the Terms and Conditions referenced here and posted at sidneylee.com.\nThe undersigned hereby understands and accepts the terms outlined above",
      fields: [

        { name: "printName", label: "Print Name", type: "text", required: true },
        { name: "signatureFont", label: "Signature Style", type: "select", required: true,
          options: [
            { value: "Great Vibes", label: "Great Vibes" },
            { value: "Dancing Script", label: "Dancing Script" },
            { value: "Allura", label: "Allura" },
            { value: "Pacifico", label: "Pacifico" },
            { value: "Sacramento", label: "Sacramento" },
          ]
        },         
        { name: "signature", label: "Signature", type: "signature", required: true },        
        { name: "title", label: "Title", type: "text", required: true },
        { name: "date", label: "Date", type: "date", required: true },
      ]
    }
  ],

  "New Account Application - Commercial": [
    // — Commercial Information —
    {
      title: "Commercial Information",
      fields: [
        { name: "companyLegalName", label: "Company’s Legal Name", type: "text", required: true, maxLength: 50, hint: "Tip: max 50 characters — our account system can’t accept longer names. Abbreviate if needed (e.g. LLC, LLLP)." },
        { name: "yearsInBusiness", label: "Years in Business", type: "number", required: true },
        { name: "dbaName", label: "DBA Business Name", type: "text", required: true },
        { name: "fedTaxId", label: "Federal Tax ID", type: "text", required: true },
        { name: "website", label: "Website", type: "text", required: false },
        { name: "mainPhone", label: "Main Phone", type: "phone", required: true },
        { name: "principleOfficer", label: "Name of Principle Officer", type: "text", required: true },
        { name: "estMonthlyPurchases", label: "Est. Monthly Purchases", type: "number", required: true },
        { name: "poRequired", label: "P/O Required", type: "checkbox", required: false },
        { name: "taxExempt", label: "Tax Exempt", type: "checkbox", required: false },
        { name: "accountsPayableContact", label: "Accounts Payable Contact", type: "text", required: true },
        { name: "apEmail", label: "AP Email", type: "text", required: true },
      ]
    },

    // — Address Information —
    {
      title: "Address Information",
      shipping: false,
      fields: [
        { name: "billingAddress", label: "Billing Address", type: "text", required: true },
        { name: "billingAddress2", label: "Billing Address 2", type: "text", required: false },        
        { name: "billingCity", label: "City", type: "text", required: true },
        { name: "billingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "billingZip", label: "Zip Code", type: "text", required: true },
        { name: "billingContact", label: "Billing Contact", type: "text", required: true },
        { name: "billingPhone", label: "Billing Phone", type: "phone", required: true },
        { name: "billingExt", label: "Extension", type: "phone", required: false },
        { name: "billingEmail", label: "Billing Email", type: "text", required: true },
      ]
    },
    // — Shipping (required; can copy from billing) —
    {
      title: "Shipping Information",
      sectionInfo: "Required. Check \"Same as Billing Address\" to copy your billing details.",
      fields: [
        { name: "shippingBusinessName", label: "Business Name", type: "text", required: true, maxLength: 50, hint: "Tip: max 50 characters — our account system can’t accept longer names. Abbreviate if needed (e.g. LLC, LLLP)." },
        { name: "shippingAddress", label: "Shipping Address", type: "text", required: true },
        { name: "shippingAddress2", label: "Shipping Address 2", type: "text", required: false },
        { name: "shippingCity", label: "City", type: "text", required: true },
        { name: "shippingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "shippingZip", label: "Zip Code", type: "text", required: true },
        { name: "shippingContact", label: "Shipping Contact", type: "text", required: true },
        { name: "shippingPhone", label: "Shipping Phone", type: "phone", required: true },
        { name: "shippingExt", label: "Extension", type: "phone", required: false },
        { name: "shippingEmail", label: "Shipping Email", type: "text", required: true },
      ]
    },

    // Trade References
    // Include other welding supply distributors or related suppliers
    {
      title: "Trade References",
      sectionInfo: "Include other welding supply distributors or related suppliers. Please enter N/A if not applicable.",
      fields: [
        { name: "tradeName", label: "Name", type: "text", required: false },
        { name: "tradePhone", label: "Phone", type: "phone", required: false },
        { name: "tradeAccountNumber", label: "Account Number", type: "text", required: false },
        { name: "tradeAddress", label: "Address", type: "text", required: false },
        { name: "tradeCity", label: "City", type: "text", required: false },
        { name: "tradeState", label: "State", type: "select", required: false, options: US_STATES },
        { name: "tradeZip", label: "Zip", type: "text", required: false },

        { name: "tradeName2", label: "Name", type: "text", required: false },
        { name: "tradePhone2", label: "Phone", type: "phone", required: false },
        { name: "tradeAccountNumber2", label: "Account Number", type: "text", required: false },
        { name: "tradeAddress2", label: "Address", type: "text", required: false },
        { name: "tradeCity2", label: "City", type: "text", required: false },
        { name: "tradeState2", label: "State", type: "select", required: false, options: US_STATES },
        { name: "tradeZip2", label: "Zip", type: "text", required: false },
      ]
    },
    // need to be able to dynamically add more of these

    // — Signature block —
    {
      title: "TERMS: Net 30 Days from the Invoice Date",
      sectionInfo: "Payment is due within 30 days unless otherwise agreed in writing. Past-due accounts may incur finance charges. Sidney Lee Welding Supply, Inc. reserves the right to suspend credit or place accounts on C.O.D. at any time based on payment history. Cylinders remain the property of Sidney Lee Welding supply, Inc. Rental charges apply unless specified otherwise. We reserve the right to reclaim rented cylinders if invoices remain unpaid or the lease is terminated. Full Terms of Service available at sidneylee.com.\n\nI certify that the information provided in this application is correct and that I am authorized to request credit on behalf of the applicant. \n\nI authorize Sidney Lee Welding Supply, Inc. to verify credit references and use other sources as needed. I agree to the Terms and Conditions referenced here and posted at sidneylee.com.\nThe undersigned hereby understands and accepts the terms outlined above",
      fields: [

        { name: "printName", label: "Print Name", type: "text", required: true },
        { name: "signatureFont", label: "Signature Style", type: "select", required: true,
          options: [
            { value: "Great Vibes", label: "Great Vibes" },
            { value: "Dancing Script", label: "Dancing Script" },
            { value: "Allura", label: "Allura" },
            { value: "Pacifico", label: "Pacifico" },
            { value: "Sacramento", label: "Sacramento" },
          ]
        },         
        { name: "signature", label: "Signature", type: "signature", required: true },        
        { name: "title", label: "Title", type: "text", required: true },
        { name: "date", label: "Date", type: "date", required: true },
      ]
    }
  ],

  "New Owner (TO) Credit Application": [
    // — Commercial Information —
    {
      title: "Commercial Information",
      fields: [
        { name: "companyLegalName", label: "Company’s Legal Name", type: "text", required: true, maxLength: 50, hint: "Tip: max 50 characters — our account system can’t accept longer names. Abbreviate if needed (e.g. LLC, LLLP)." },
        { name: "yearsInBusiness", label: "Years in Business", type: "number", required: true },
        { name: "dbaName", label: "DBA Business Name", type: "text", required: true },
        { name: "fedTaxId", label: "Federal Tax ID", type: "text", required: true },
        { name: "website", label: "Website", type: "text", required: false },
        { name: "mainPhone", label: "Main Phone", type: "phone", required: true },
        { name: "principleOfficer", label: "Name of Principle Officer", type: "text", required: true },
        { name: "estMonthlyPurchases", label: "Est. Monthly Purchases", type: "number", required: true },
        { name: "poRequired", label: "P/O Required", type: "checkbox", required: false },
        { name: "taxExempt", label: "Tax Exempt", type: "checkbox", required: false },
        { name: "accountsPayableContact", label: "Accounts Payable Contact", type: "text", required: true },
        { name: "apEmail", label: "AP Email", type: "text", required: true },
      ]
    },

    // — Address Information —
    {
      title: "Address Information",
      shipping: false,
      fields: [
        { name: "billingAddress", label: "Billing Address", type: "text", required: true },
        { name: "billingAddress2", label: "Billing Address 2", type: "text", required: false },        
        { name: "billingCity", label: "City", type: "text", required: true },
        { name: "billingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "billingZip", label: "Zip Code", type: "text", required: true },
        { name: "billingContact", label: "Billing Contact", type: "text", required: true },
        { name: "billingPhone", label: "Billing Phone", type: "phone", required: true },
        { name: "billingExt", label: "Extension", type: "phone", required: false },
        { name: "billingEmail", label: "Billing Email", type: "text", required: true },
      ]
    },

    // — Signature block —
    {
      title: "TERMS: Net 30 Days from the Invoice Date",
      sectionInfo: "Payment is due within 30 days unless otherwise agreed in writing. Past-due accounts may incur finance charges. Sidney Lee Welding Supply, Inc. reserves the right to suspend credit or place accounts on C.O.D. at any time based on payment history. Cylinders remain the property of Sidney Lee Welding supply, Inc. Rental charges apply unless specified otherwise. We reserve the right to reclaim rented cylinders if invoices remain unpaid or the lease is terminated. Full Terms of Service available at sidneylee.com.\n\nI certify that the information provided in this application is correct and that I am authorized to request credit on behalf of the applicant. \n\nI authorize Sidney Lee Welding Supply, Inc. to verify credit references and use other sources as needed. I agree to the Terms and Conditions referenced here and posted at sidneylee.com.\nThe undersigned hereby understands and accepts the terms outlined above",
      fields: [

        { name: "printName", label: "Print Name", type: "text", required: true },
        { name: "signatureFont", label: "Signature Style", type: "select", required: true,
          options: [
            { value: "Great Vibes", label: "Great Vibes" },
            { value: "Dancing Script", label: "Dancing Script" },
            { value: "Allura", label: "Allura" },
            { value: "Pacifico", label: "Pacifico" },
            { value: "Sacramento", label: "Sacramento" },
          ]
        },         
        { name: "signature", label: "Signature", type: "signature", required: true },        
        { name: "title", label: "Title", type: "text", required: true },
        { name: "date", label: "Date", type: "date", required: true },
      ]
    }
  ],

  "New Owner (NA) Credit Application": [
    // — Commercial Information —
    {
      title: "Commercial Information",
      fields: [
        { name: "companyLegalName", label: "Company’s Legal Name", type: "text", required: true, maxLength: 50, hint: "Tip: max 50 characters — our account system can’t accept longer names. Abbreviate if needed (e.g. LLC, LLLP)." },
        { name: "yearsInBusiness", label: "Years in Business", type: "number", required: true },
        { name: "dbaName", label: "DBA Business Name", type: "text", required: true },
        { name: "fedTaxId", label: "Federal Tax ID", type: "text", required: true },
        { name: "website", label: "Website", type: "text", required: false },
        { name: "mainPhone", label: "Main Phone", type: "phone", required: true },
        { name: "principleOfficer", label: "Name of Principle Officer", type: "text", required: true },
        { name: "estMonthlyPurchases", label: "Est. Monthly Purchases", type: "number", required: true },
        { name: "poRequired", label: "P/O Required", type: "checkbox", required: false },
        { name: "taxExempt", label: "Tax Exempt", type: "checkbox", required: false },
        { name: "accountsPayableContact", label: "Accounts Payable Contact", type: "text", required: true },
        { name: "apEmail", label: "AP Email", type: "text", required: true },
      ]
    },

    // — Address Information —
    {
      title: "Address Information",
      shipping: false,
      fields: [
        { name: "billingAddress", label: "Billing Address", type: "text", required: true },
        { name: "billingAddress2", label: "Billing Address 2", type: "text", required: false },        
        { name: "billingCity", label: "City", type: "text", required: true },
        { name: "billingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "billingZip", label: "Zip Code", type: "text", required: true },
        { name: "billingContact", label: "Billing Contact", type: "text", required: true },
        { name: "billingPhone", label: "Billing Phone", type: "phone", required: true },
        { name: "billingExt", label: "Extension", type: "phone", required: false },
        { name: "billingEmail", label: "Billing Email", type: "text", required: true },
      ]
    },
    // — Shipping (required; can copy from billing) —
    {
      title: "Shipping Information",
      sectionInfo: "Required. Check \"Same as Billing Address\" to copy your billing details.",
      fields: [
        { name: "shippingBusinessName", label: "Business Name", type: "text", required: true, maxLength: 50, hint: "Tip: max 50 characters — our account system can’t accept longer names. Abbreviate if needed (e.g. LLC, LLLP)." },
        { name: "shippingAddress", label: "Shipping Address", type: "text", required: true },
        { name: "shippingAddress2", label: "Shipping Address 2", type: "text", required: false },
        { name: "shippingCity", label: "City", type: "text", required: true },
        { name: "shippingState", label: "State", type: "select", required: true, options: US_STATES },
        { name: "shippingZip", label: "Zip Code", type: "text", required: true },
        { name: "shippingContact", label: "Shipping Contact", type: "text", required: true },
        { name: "shippingPhone", label: "Shipping Phone", type: "phone", required: true },
        { name: "shippingExt", label: "Extension", type: "phone", required: false },
        { name: "shippingEmail", label: "Shipping Email", type: "text", required: true },
      ]
    },

    // — Signature block —
    {
      title: "TERMS: Net 30 Days from the Invoice Date",
      sectionInfo: "Payment is due within 30 days unless otherwise agreed in writing. Past-due accounts may incur finance charges. Sidney Lee Welding Supply, Inc. reserves the right to suspend credit or place accounts on C.O.D. at any time based on payment history. Cylinders remain the property of Sidney Lee Welding supply, Inc. Rental charges apply unless specified otherwise. We reserve the right to reclaim rented cylinders if invoices remain unpaid or the lease is terminated. Full Terms of Service available at sidneylee.com.\n\nI certify that the information provided in this application is correct and that I am authorized to request credit on behalf of the applicant. \n\nI authorize Sidney Lee Welding Supply, Inc. to verify credit references and use other sources as needed. I agree to the Terms and Conditions referenced here and posted at sidneylee.com.\nThe undersigned hereby understands and accepts the terms outlined above",
      fields: [

        { name: "printName", label: "Print Name", type: "text", required: true },
        { name: "signatureFont", label: "Signature Style", type: "select", required: true,
          options: [
            { value: "Great Vibes", label: "Great Vibes" },
            { value: "Dancing Script", label: "Dancing Script" },
            { value: "Allura", label: "Allura" },
            { value: "Pacifico", label: "Pacifico" },
            { value: "Sacramento", label: "Sacramento" },
          ]
        },
        { name: "signature", label: "Signature", type: "signature", required: true },
        { name: "title", label: "Title", type: "text", required: true },
        { name: "date", label: "Date", type: "date", required: true },
      ]
    }
  ]
};
